// Validated categorical slots (dataviz reference palette, light mode)
export const COLORS = {
  subs: '#2a78d6',
  ads: '#1baf7a',
  spend: '#eb6834',
  profit: '#4a3aa7',
  installsPaid: '#eb6834',
  installsOther: '#2a78d6',
  avg: '#4a3aa7',
};

// Ages (days since signup) shown in the earnings table; a subset of COHORT_AGES in refreshAnalytics
export const TABLE_AGES = [7, 30, 90, 180, 365, 540, 912];
// Months with fewer users are too noisy to show as their own row (they still count in the typical user)
export const MIN_TABLE_USERS = 20;

// Finnish format: 1 234,56 € (sign after the number)
export const eurFormat = new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const eurCents = new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function eur(v, cents = false) {
  if (v == null || Number.isNaN(v)) return '–';
  return (cents || Math.abs(v) < 10 ? eurCents : eurFormat).format(v);
}
export const eurRange = (low, high) => (high == null || Math.abs(high - low) < 0.005 ? eur(low, true) : `${eur(low, true)}–${eur(high, true)}`);
export const ageLabel = (a) => ({ 0: 'Day 1', 365: '1 year', 395: '13 months', 540: '1.5 years', 730: '2 years', 912: '2.5 years' }[a] || `${a} days`);
// Earnings chart x position: true to scale for the first year; after it, 1 -> 1.5 -> 2.5 years get
// equal widths so the extrapolated tail doesn't take up half the chart. [age, x] breakpoints,
// linear in between.
const X_SCALE = [[0, 0], [365, 365], [540, 425], [912, 485]];
function piecewise(v, from, to) {
  for (let i = 1; i < X_SCALE.length; i++) {
    const [a0, a1] = [X_SCALE[i - 1][from], X_SCALE[i][from]];
    if (v <= a1 || i === X_SCALE.length - 1) {
      return X_SCALE[i - 1][to] + ((v - a0) / (a1 - a0)) * (X_SCALE[i][to] - X_SCALE[i - 1][to]);
    }
  }
  return v;
}
export const ageToX = (a) => piecewise(a, 0, 1);
export const xToAgeLabel = (x) => ageLabel(Math.round(piecewise(x, 1, 0)));
export const LABELLED_AGES = [0, 30, 90, 180, 270, 365, 540, 912];
export const horizonLabel = (a) => (a === 365 ? 'first year' : a === 395 ? 'first year plus renewal' : a === 730 ? 'first two years' : a === 0 ? 'first day' : `first ${a} days`);
